import { ArrowUpRight } from "lucide-react";
import { NAV_LINKS, CONTACT, scrollToSection } from "../lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-amber-500/15 bg-[#0b0c10]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
        <div className="font-mono-x text-[10px] tracking-[0.3em] uppercase text-gray-500 mb-5">Coding In Store</div>
          <p className="mt-4 text-sm text-gray-500 leading-relaxed max-w-sm">
            Your online cashier. Direct online ordering, order management, delivery tracking and
            analytics for independent food businesses — with zero commission.
          </p>
          <a
            data-testid="footer-demo-link"
            href="https://onlinekebab.store"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-5 inline-flex items-center gap-1.5 font-mono-x text-xs tracking-[0.2em] uppercase text-amber-500 hover:text-amber-400 transition-colors duration-200"
          >
            Demo Link <ArrowUpRight className="w-3.5 h-3.5" />
          </a>
        </div>
        <div className="md:col-span-3">
          <div className="font-mono-x text-[10px] tracking-[0.3em] uppercase text-gray-500 mb-5">Navigate</div>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <button
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => scrollToSection(l.id)}
                  className="text-sm text-gray-400 hover:text-amber-400 transition-colors duration-200"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="font-mono-x text-[10px] tracking-[0.3em] uppercase text-gray-500 mb-5">Contact</div>
          <ul className="space-y-3 text-sm text-gray-400">
            <li>{CONTACT.address}</li>
            <li>
              <a data-testid="footer-phone-link" href={CONTACT.phoneHref} className="hover:text-amber-400 transition-colors duration-200">{CONTACT.phone}</a>
            </li>
            <li>
              <a data-testid="footer-email-link" href={CONTACT.emailHref} className="hover:text-amber-400 transition-colors duration-200">{CONTACT.email}</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p data-testid="footer-copyright" className="font-mono-x text-[11px] tracking-[0.15em] text-gray-600">
            © {new Date().getFullYear()} CODING IN STORE. ALL RIGHTS RESERVED.
          </p>
          <p className="font-mono-x text-[11px] tracking-[0.15em] text-gray-600">YOUR ONLINE CASHIER</p>
        </div>
      </div>
    </footer>
  );
}
